export default function toBaseLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var dashIndex = locale.indexOf('-');

  if (dashIndex > -1) {
    return locale.slice(0, dashIndex);
  }

  var underscoreIndex = locale.indexOf('_');

  if (underscoreIndex > -1) {
    return locale.slice(0, underscoreIndex);
  }

  return locale;
}